import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { Interceptor } from '../../token/interceptor';
import { TipoInfraestructuraService } from '../tipoInfraestructura/tipoInfraestructura.service';
import { TipoResidenciaService } from '../tipoResidencia/tipoResidencia.service';
import { TipoMobiliarioService } from '../tipoMobiliario/tipoMobiliario.service';
import { TipoPagoService } from '../tipoPago/tipoPago.service';
import { TipoSancionService } from '../tipoSancion/tipoSancion.service';
import { PrecioResidenciaService } from '../precioResidencia/precioResidencia.service';
import { TipoEstadoAvanceService } from '../tipoEstadoAvance/tipoEstadoAvance.service';
import { InfraestructuraService } from '../infraestructura/infraestructura.service';
import { ResidenciaService } from '../residencia/residencia.service';
import { SancionService } from '../sancion/sancion.service';
import { EstadoResidenciaService } from '../estadoResidencia/estadoResidencia.service';
import { GrupoSocioeconomicoResidenciaService } from '../grupoSocioeconomicoResidencia/grupoSocioeconomicoResidencia.service';
import { ParametroService } from '../parametro/parametro.service';
import { SeguPeriodoService } from '../../seguridad/seguPeriodo/seguPeriodo.service';
import { PrecioService } from '../precio/precio.service';
import { SolicitudService } from '../solicitud/solicitud.service';
import { GeneroService } from '../solicitud/genero.service';
import { ResidenteService } from '../residente/residente.service';
import { SolicitudTipoEstadoAvanceService } from '../solicitudTipoEstadoAvance/solicitudTipoEstadoAvance.service';
import { TipoCambioService } from '../tipoCambio/tipoCambio.service';
import { ResidenteTipoCambioService } from '../residenteTipoCambio/residenteTipoCambio.service';
import { TipoGpseService } from '../../bienestar/tipoGpse/tipoGpse.service';
import { TipoSolicitudService } from '../tipoSolicitud/tipoSolicitud.service';
import { InfraestructuraTipoMobiliarioService } from '../infraestructuraTipoMobiliario/infraestructuraTipoMobiliario.service';
import { TipoCondicionBienService } from '../tipoCondicionBien/tipoCondicionBien.service';
import { PuntosGeoreferencialesService } from '../puntosGeoreferenciales/puntosGeoreferenciales.service';
import { TipoSalidaService } from '../tipoSalida/tipoSalida.service';
import { ResidenteTipoSalidaService } from '../residenteTipoSalida/residenteTipoSalida.service';
import { ReporteGeneralResidenciaService } from '../reporte-general-residencia/ReporteGeneralResidenciaService';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedResidenciaModule {
  static forRoot(): ModuleWithProviders<SharedResidenciaModule> {
    return {
      ngModule: SharedResidenciaModule,
      providers: [
        TipoInfraestructuraService,
        TipoResidenciaService,
        TipoMobiliarioService,
        TipoCondicionBienService,
        TipoPagoService,
        TipoSolicitudService,
        TipoSancionService,
        TipoEstadoAvanceService,
        TipoCambioService,
        PrecioResidenciaService,
        ParametroService,
        InfraestructuraService,
        ResidenciaService,
        SancionService,
        EstadoResidenciaService,
        SeguPeriodoService,
        GrupoSocioeconomicoResidenciaService,
        TipoGpseService,
        PrecioService,
        ReporteGeneralResidenciaService,
        SolicitudService,
        GeneroService,
        ResidenteService,
        InfraestructuraTipoMobiliarioService,
        SolicitudTipoEstadoAvanceService,
        ResidenteTipoCambioService,
        TipoEstadoAvanceService,
        PuntosGeoreferencialesService,
        TipoSalidaService,
        ResidenteTipoSalidaService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
